import React, { useEffect, useState } from 'react';
import { getdata } from "../../util/global";

const ReceivedMessage = () => { 
  const [messagedata, setmessagedata] = useState([]);


  const fetchdata = async () => {
    try {
      const data = await getdata({ filter: { datatype: "receivemessagedata" } });
      setmessagedata(data.sort((a, b) => {
        return b.message?.t > a.message?.t;
      }));
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchdata();
  }, []);

  return (
    <div className="content-area">
      <div className="table-header-row">
      </div>

      <table className="grid">
        <thead>
          <tr>
           <th>timestamp</th><th>phonenumber</th><th>name</th> <th>message</th>
          </tr>
        </thead>
        <tbody>
          {messagedata.filter((item) => {
            return item.message?.body && item.message.body.trim() != "";
          }).map((item, i) => (
            <tr key={item._id || i}>
              <td>{item.updatetimestamp}</td>
              <td>{item.sendercontact?.id?.user}</td>
              <td>{item.sendercontact?.name}</td>
              <td>{item.message?.body?.match(/^\/9j\//gi) ? "[IMAGE]" : item.message?.body}</td>

            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ReceivedMessage;